import { connect } from "react-redux";
import Main from "./Main";
import { setPixelObject, noteAnswer } from "../../store/questions/actions";

const mapStateToProps = (state) => {
  return {
    pixelObject: state.questions.pixelObject,
    remoteConfig: state.questions.remoteConfig,
    isAnalyticsInit: state.questions.isAnalyticsInit,
  };
};

const mapDispatchToProps = {
  setPixelObject,
  noteAnswer,
};

export default connect(mapStateToProps, mapDispatchToProps)(Main);
